import { FlashOn } from '@material-ui/icons';
import * as PrimitiveToggleGroup from '@radix-ui/react-toggle-group';
import { useField, useFormikContext } from 'formik';
import { TEMPLATES } from './constants';

const TemplateSelect = () => {
  const { values, setFieldValue } = useFormikContext();
  const [field, , helpers] = useField('template');

  const handleValueChange = value => {
    const scopeTextEmpty = values['text'] === '';
    const scopeTextDirty = values['template'] ? values['text'] !== TEMPLATES[values['template']].scope : false;
    const togglingOff = value === '';

    // Warn users replacing text
    if (!scopeTextEmpty && !togglingOff && scopeTextDirty) {
      const userResponse = confirm(
        'You will lose your text if you change to a preset template. Are you sure you want to continue?',
      );
      if (!userResponse) {
        return;
      }
    }

    // Prevent toggling template off - unclear what that should do
    if (togglingOff) {
      return;
    }

    // Update the toggle
    helpers.setValue(value);

    // Update the scope text
    setFieldValue('text', TEMPLATES[value].scope);
  };

  return (
    <PrimitiveToggleGroup.Root
      aria-label="Template"
      className="inline-flex flex-shrink space-x-2 flex-wrap p-1 rounded-2xl border border-gray-200"
      type="single"
      defaultValue={null}
      value={field.value}
      onValueChange={handleValueChange}
    >
      {Object.entries(TEMPLATES).map(([key, { title }]) => (
        <PrimitiveToggleGroup.Item
          key={key}
          value={key}
          className="flex items-center justify-center p-3 rounded-xl border border-gray-200 data-[state=on]:bg-yellow-900 data-[state=on]:text-yellow-50 text-sm md:text-base leading-4"
          aria-label={title}
        >
          <FlashOn fontSize="small" className="mr-1 text-orange-300" />
          <span>{title}</span>
        </PrimitiveToggleGroup.Item>
      ))}
    </PrimitiveToggleGroup.Root>
  );
};

export default TemplateSelect;
